import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import styles from './styles.scss';

export default function HomepageFeaturedLandingPageTags({ tags }) {
  if (tags.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles['list-title']}>{i18n.gettext('Need some more options?')}</h2>
        <ul className={styles.list}>
          {tags.map((tag) => (
            <li key={tag.id}>
              <a href={tag.href}>{tag.name}</a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

HomepageFeaturedLandingPageTags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      href: PropTypes.string,
    }),
  ).isRequired,
};
